import { VueCharts, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

const lineChartData = {
  labels: [],
  datasets: [
    {
      label: 'Current Score',
      borderColor: '#008001',
      backgroundColor: '#008001',
      fontColor: '#f0f',
      data: [],
      fill: false,
      datalabels: {
        formatter() {
          return '';
        }
      }
    },
    {
      label: 'Industry Average',
      borderColor: '#000000',
      backgroundColor: '#000000',
      fontColor: '#f0f',
      data: [],
      fill: false,
      datalabels: {
        formatter() {
          return '';
        }
      }
    },
    {
      label: 'Industry Best',
      borderColor: '#0000FF',
      backgroundColor: '#0000FF',
      fontColor: '#f0f',
      data: [],
      fill: false,
      datalabels: {
        formatter() {
          return '';
        }
      }
    },
    {
      label: 'Industry Worst',
      borderColor: '#FF0000',
      backgroundColor: '#FF0000',
      data: [],
      fill: false,
      datalabels: {
        formatter() {
          return '';
        }
      }
    }
  ]
};

export default {
  extends: VueCharts.Line,
  mixins: [reactiveProp],
  props: [
    'chartData',
    'type',
    'industryData'
  ],
  watch: {
    chartData: {
      handler(newData) {
        if (newData) this.draw();
      }
    }
  },
  mounted() {
    this.addPlugin({
      beforeDraw(chartInstance) {
        const ctx = chartInstance.chart.ctx; // eslint-disable-line prefer-destructuring
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, chartInstance.chart.width, chartInstance.chart.height);
      }
    });

    const positive = this.type === 'positive';
    this.addPlugin({
      afterDraw(chartInstance) {
        const chartArea = chartInstance.chart.chartArea; // eslint-disable-line prefer-destructuring
        const ctx = chartInstance.chart.ctx; // eslint-disable-line prefer-destructuring
        ctx.fillStyle = 'rgba(0,0,0,0.05)';
        ctx.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        ctx.fillStyle = 'rgba(127,127,127,1)';
        ctx.strokeStyle = 'rgba(127,127,127,1)';
        ctx.fillRect(chartArea.right + 50, chartArea.top + 90, 30, 150);
        ctx.beginPath();
        if (!positive) {
          // bottom left
          ctx.moveTo(chartArea.right + 35, chartArea.top + 239);
          // bottom right
          ctx.lineTo(chartArea.right + 95, chartArea.top + 239);
          // bottom
          ctx.lineTo(chartArea.right + 65, chartArea.top + 290);
        } else {
          // top left
          ctx.moveTo(chartArea.right + 35, chartArea.top + 91);
          // bottom right
          ctx.lineTo(chartArea.right + 95, chartArea.top + 91);
          // top
          ctx.lineTo(chartArea.right + 65, chartArea.top + 60);
        }
        ctx.fill();

        // now write
        ctx.save();
        ctx.rotate((positive ? -0.5 : 0.5) * Math.PI);
        ctx.fillStyle = 'rgba(255,255,255,1)';
        ctx.font = 'bold 16px Arial';
        ctx.textAlign = 'center';
        if (positive) {
          ctx.fillText('Increase', -1 * chartArea.top - 150, chartArea.right + 65);
        } else {
          ctx.fillText('Decrease', chartArea.top + 160, -1 * chartArea.right - 65);
        }

        ctx.restore();
      }
    });

    if (this.chartData) this.draw();
  },
  methods: {
    draw() {
      // clear out old
      lineChartData.datasets[0].data = [null];
      lineChartData.datasets[1].data = [null];
      lineChartData.datasets[2].data = [null];
      lineChartData.datasets[3].data = [null];

      // now calculate
      const positive = this.type === 'positive';
      const totals = [];
      const elements = [];

      // filter for type of element
      this.chartData.filter((scoreRow) => {
        if (positive && !scoreRow.scoreBackwards) return true;
        if (!positive && scoreRow.scoreBackwards) return true;
        return false;
      }).forEach((scoreRow) => {
        // add to elements and totals
        if (elements.indexOf(scoreRow.elementName) === -1) {
          elements.push(scoreRow.elementName);
          totals.push({
            responses: 0,
            cumulativeScore: 0
          });
        }
        const elementIndex = elements.indexOf(scoreRow.elementName);

        totals[elementIndex].responses += parseInt(scoreRow.numberOfResponses, 10);
        totals[elementIndex].cumulativeScore += parseInt(scoreRow.numberOfResponses, 10) * parseFloat(scoreRow.averageScore);
      });

      // get ready to add
      const industryScores = this.industryData.elements.reduce((accumulator, element) => {
        accumulator[element.local_name] = element;
        return accumulator;
      }, {});


      // add the scores to the chart
      totals.forEach((total, index) => {
        lineChartData.datasets[0].data.push(total.cumulativeScore / total.responses);
        lineChartData.datasets[1].data.push(industryScores[elements[index]].average);
        lineChartData.datasets[2].data.push(positive ? industryScores[elements[index]].maximum : industryScores[elements[index]].minimum);
        lineChartData.datasets[3].data.push(positive ? industryScores[elements[index]].minimum : industryScores[elements[index]].maximum);
      });

      lineChartData.labels = elements;
      lineChartData.labels.unshift('');
      lineChartData.labels.push('');

      // console.log('lineChartData');
      // console.log(lineChartData);

      this.renderChart(lineChartData, {
        responsive: false,
        maintainAspectRatio: true,
        layout: {
          padding: {
            right: 100
          }
        },
        elements: {
          line: {
            tension: 0
          }
        },
        legend: {
          position: 'bottom',
          labels: {
            usePointStyle: true,
            fontColor: "#000000",
            fontFamily: "Stag-Sans-Book"
          }
        },
        title: {
          display: true,
          text: `Industry ${positive ? 'Positive Elements' : 'Limiters'} (DO ${positive ? 'MORE' : 'LESS'})`,
          fontStyle: 'bold',          
          fontColor: '#000000',
          fontFamily: 'Stag-Black',
          fontSize: 24
        },
        scales: {
          xAxes: [
            {
              ticks: {
                display: true,
                fontStyle: 'bold',
                fontSize: 12,
                autoSkip: false
              },
              gridLines: {
                display: true,
                color: '#000000',
                lineWidth: 1,
                drawOnChartArea: true,
                borderDashOffset: -10
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                display: true,
                min: 1,
                max: 4,
                stepSize: 1,
                fontColor: '#000000'
              },
              gridLines: {
                display: true,
                color: '#000000',
                lineWidth: 1,
                drawOnChartArea: true,
                borderDashOffset: -10
              }
            },
            {
              position: 'left',
              offset: false,
              ticks: {
                display: true,
                fontColor: positive ? '#2E455F' : '#953735',
                fontStyle: 'bold',
                min: 1,
                max: 4,
                stepSize: 1,
                callback(label, index) {
                  switch (index) {
                  case 0:
                    return positive ? 'VERY GOOD' : 'POOR';
                  case 1:
                    return positive ? 'GOOD' : 'NOT SO GOOD';
                  case 2:
                    return positive ? 'NOT SO GOOD' : 'GOOD';
                  case 3:
                    return positive ? 'POOR' : 'VERY GOOD';
                  default:
                    return '';
                  }
                }
              },
              gridLines: {
                drawBorder: false
              }
            }
          ]
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/graphs/ElementIndustryLine.js